(() => {
  const money = (value) => new Intl.NumberFormat('es-CL', { style: 'currency', currency: 'CLP', maximumFractionDigits: 0 }).format(value);
  class StohShipping extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('form');
      this.region = this.querySelector('[data-shipping-region]');
      this.output = this.querySelector('[data-rate-output]');
      this.guidance = this.querySelector('[data-delivery-guidance]');
      this.button = this.querySelector('button');
      this.version = 0;
      this.destination = this.querySelector('[data-shipping-destination]');
      this.extraFields = this.querySelector('[data-shipping-fields]');
      const country = this.querySelector('[data-shipping-country] option');
      let provinces = [];
      try { provinces = JSON.parse(country?.dataset.provinces || '[]'); } catch (error) { provinces = []; }
      provinces.forEach(([value, label]) => this.region.add(new Option(label || value, value)));
      this.form.addEventListener('submit', (event) => { event.preventDefault(); this.calculate(); });
      this.form.addEventListener('input', () => this.invalidate(false));
      this.region.addEventListener('change', () => this.showGuidance());
      this.destination?.addEventListener('change', () => {
        const other = this.destination.value === 'other';
        this.extraFields.hidden = !other;
        if (other) { this.region.value = ''; this.querySelector('[data-shipping-city]').value = ''; return; }
        if (!this.destination.value) return;
        const rmOption = [...this.region.options].find((option) => /santiago|metropolitana/i.test(option.value));
        if (!rmOption) { this.extraFields.hidden = false; return; }
        this.region.value = rmOption.value;
        this.querySelector('[data-shipping-city]').value = this.destination.value;
        this.showGuidance();
      });
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') this.unsubscribe = subscribe(PUB_SUB_EVENTS.cartUpdate, () => this.invalidate(true));
    }
    disconnectedCallback() { this.unsubscribe?.(); this.controller?.abort(); }
    showGuidance() {
      const value = this.region.value.toLowerCase();
      this.guidance.textContent = /santiago|metropolitana/.test(value) ? this.dataset.rm : this.dataset.regions;
      this.guidance.hidden = !this.region.value;
    }
    invalidate(cartChanged) {
      this.version += 1;
      this.controller?.abort();
      if (this.button) this.button.disabled = false;
      this.output.replaceChildren();
      if (cartChanged && this.dataset.context === 'cart') this.output.textContent = this.dataset.invalidated;
      document.querySelectorAll('[data-stoh-shipping-summary]').forEach((node) => { node.textContent = node.dataset.pending; });
    }
    async calculate() {
      if (!this.form.reportValidity()) return;
      this.showGuidance();
      if (this.dataset.context !== 'cart') { this.output.textContent = this.guidance.textContent; return; }
      this.controller?.abort();
      this.controller = new AbortController();
      const token = ++this.version;
      const params = new URLSearchParams({
        'shipping_address[country]': 'Chile',
        'shipping_address[province]': this.region.value,
        'shipping_address[city]': this.querySelector('[data-shipping-city]').value.trim()
      });
      const postal = this.querySelector('[data-shipping-postal]')?.value.trim();
      if (postal) params.set('shipping_address[zip]', postal);
      const root = this.dataset.root.endsWith('/') ? this.dataset.root : `${this.dataset.root}/`;
      this.output.textContent = this.dataset.loading;
      this.button.disabled = true;
      try {
        const response = await fetch(`${root}cart/prepare_shipping_rates.json?${params}`, { method: 'POST', signal: this.controller.signal });
        if (!response.ok) throw new Error('shipping');
        let result = null;
        for (let n = 0; n < 12; n += 1) {
          const rates = await fetch(`${root}cart/async_shipping_rates.json?${params}`, { signal: this.controller.signal, cache: 'no-store' });
          if (!rates.ok) throw new Error('shipping');
          result = await rates.json();
          if (result?.shipping_rates) break;
          await new Promise((resolve) => setTimeout(resolve, 1000));
          if (token !== this.version) return;
        }
        if (token !== this.version) return;
        this.output.replaceChildren();
        if (!result?.shipping_rates?.length) { this.output.textContent = this.dataset.noRates; return; }
        const list = document.createElement('ul');
        list.className = 'stoh-shipping__rates';
        result.shipping_rates.forEach((rate) => {
          const row = document.createElement('li');
          const label = document.createElement('span');
          const price = document.createElement('strong');
          label.textContent = rate.presentment_name || rate.name;
          price.textContent = money(Number(rate.price));
          row.append(label, price); list.append(row);
        });
        this.output.append(list);
        const minimum = Math.min(...result.shipping_rates.map((rate) => Number(rate.price)));
        document.querySelectorAll('[data-stoh-shipping-summary]').forEach((node) => { node.textContent = `Desde ${money(minimum)}`; });
      } catch (error) {
        if (error.name !== 'AbortError' && token === this.version) this.output.textContent = this.dataset.error;
      } finally { if (token === this.version) this.button.disabled = false; }
    }
  }
  if (!customElements.get('stoh-shipping')) customElements.define('stoh-shipping', StohShipping);
  const initializeHero = () => {
    document.querySelectorAll('.stoh-hero__products').forEach((products) => {
      if (products.querySelector('.stoh-hero-mobile-link')) return;
      const link = products.closest('.stoh-hero__layout').querySelector('.stoh-hero__copy>.stoh-button');
      if (!link) return;
      const mobileLink = link.cloneNode(true);
      mobileLink.classList.add('stoh-hero-mobile-link');
      products.append(mobileLink);
    });
  };
  const bindBuyBar = () => {
    document.querySelectorAll('.stoh-buy-bar').forEach((bar) => {
      const form = document.getElementById(bar.dataset.form);
      const submit = form?.querySelector('[type=submit]');
      if (!submit || bar.dataset.bound) return;
      bar.dataset.bound = 'true';
      const priceRoot = document.getElementById(bar.dataset.price);
      const sync = () => {
        const price = priceRoot?.querySelector('.price--on-sale .price-item--sale') || priceRoot?.querySelector('.price-item--regular');
        if (price) bar.querySelector('strong').textContent = price.textContent.trim();
        const button = bar.querySelector('button');
        button.disabled = submit.disabled;
        const label = button.querySelector('[data-buy-bar-label]');
        if (label) label.textContent = !submit.disabled && bar.dataset.addLabel ? bar.dataset.addLabel : (submit.querySelector('span')?.textContent.trim() || submit.textContent.trim());
      };
      bar.querySelector('button').addEventListener('click', () => { submit.click(); sync(); });
      new MutationObserver(sync).observe(form, { subtree: true, attributes: true, attributeFilter: ['disabled'], childList: true, characterData: true });
      if (priceRoot) new MutationObserver(sync).observe(priceRoot, { subtree: true, childList: true, characterData: true });
      new IntersectionObserver(([entry]) => { bar.hidden = entry.isIntersecting; }, { threshold: 0 }).observe(submit);
      sync();
    });
  };
  const bindCart = () => {
    const bar = document.querySelector('.stoh-cart-bar');
    if (!bar) return;
    const sync = () => {
      const total = document.querySelector('[data-stoh-cart-total]');
      const empty = !!document.querySelector('cart-items.is-empty');
      bar.hidden = empty || !total;
      if (total && bar.querySelector('strong').textContent !== total.textContent.trim()) bar.querySelector('strong').textContent = total.textContent.trim();
    };
    const main = document.getElementById('MainContent');
    if (main) new MutationObserver(sync).observe(main, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });
    sync();
  };
  const rotateBenefits = () => {
    const strip = document.querySelector('.stoh-benefits');
    if (!strip || matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    let index = 0;
    let interacting = false;
    strip.addEventListener('pointerenter', () => { interacting = true; });
    strip.addEventListener('pointerleave', () => { interacting = false; });
    strip.addEventListener('focusin', () => { interacting = true; });
    strip.addEventListener('focusout', () => { interacting = false; });
    const timer = setInterval(() => {
      if (!strip.isConnected) { clearInterval(timer); return; }
      if (!matchMedia('(max-width: 749px)').matches || document.hidden || interacting) return;
      index = (index + 1) % strip.children.length;
      strip.scrollTo({ left: strip.children[index].offsetLeft - strip.firstElementChild.offsetLeft, behavior: 'smooth' });
    }, 5000);
  };
  const init = () => { initializeHero(); bindBuyBar(); bindCart(); rotateBenefits(); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true }); else init();
  document.addEventListener('shopify:section:load', () => { initializeHero(); bindBuyBar(); });
})();

